import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'download-datepicker-dialog',
  templateUrl: './download-datepicker-dialog.component.html',
})
export class DownloadDatepickerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DownloadDatepickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { start_date: string | null, end_date: string | null }
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  isValid(): boolean {
    if (!this.data.start_date && !this.data.end_date) return true;
    if (this.data.start_date && this.data.end_date) {
      return new Date(this.data.end_date) >= new Date(this.data.start_date);
    }
    return true;
  }

  onExport(): void {
    let start = this.data.start_date ? this.formatDate(this.data.start_date) : undefined;
    let end = this.data.end_date ? this.formatDate(this.data.end_date) : undefined;
    this.dialogRef.close({ start_date: start, end_date: end });
  }

  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    // Format as yyyy-mm-dd in local time, not UTC
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
